import { logout } from '../../utils/auth-session';
import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import ElevvaLogo from '../Mobile/Elements/ElevvaLogo';
import Tooltip from '../ui/Tooltip/Tooltip';
import SidebarIcon from './SidebarIcon';
import { useDashboardContext } from './DashboardContext';
import './Sidebar.css';

const menuGroups = [
    { label: 'Operación diaria', items: [
        { path: '/dashboard/home', icon: 'home', label: 'Inicio', roles: ['10', '20'] },
        { path: '/dashboard/users', icon: 'users', label: 'Usuarios', roles: ['10', '20'] },
        { path: '/dashboard/mob/booking', icon: 'booking', label: 'Reservas', roles: ['10', '20', '30'] },
        { path: '/dashboard/mob/biometrics', icon: 'biometrics', label: 'Acceso y biometría', roles: ['10', '20'] },
    ] },
    { label: 'Comercial', items: [
        { path: '/dashboard/mob/guest-pass', icon: 'gift', label: 'Cortesías', roles: ['10', '20'] },
        { path: '/dashboard/mob/plans', icon: 'plans', label: 'Membresías y planes', roles: ['10', '20'] },
    ] },
    { label: 'Finanzas', items: [
        { path: '/dashboard/accounting', icon: 'accounting', label: 'Contabilidad', roles: ['10', '20'], isPro: true },
    ] },
    { label: 'Fitness y datos', items: [
        { path: '/dashboard/athletes-management', icon: 'fitness', label: 'Evolución física y comunidad', subtitle: 'Valoraciones · PRs · Planes · Eventos', roles: ['10', '20', '30'] },
        { path: '/dashboard/graphics', icon: 'charts', label: 'Gráficas', roles: ['10', '20', '30'] },
        { path: '/dashboard/notifications', icon: 'notifications', label: 'Notificaciones', roles: ['10', '20'] },
    ] },
    { label: 'Administración', items: [
        { path: '/dashboard/mob/config', icon: 'schedule', label: 'Programación', subtitle: 'Sedes · Instructores · Servicios · Horarios', roles: ['10', '20'] },
        { path: '/dashboard/mob/admin', icon: 'reports', label: 'Reportes', roles: ['10'] },
        { path: '/dashboard/account', icon: 'settings', label: 'Mi cuenta', roles: ['10', '20'] },
    ] },
];

export default function Sidebar({ toggleSidebar, isCollapsed }) {
    const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth <= 991);
    const { company } = useDashboardContext();
    const companyName = company?.name || company?.commercial_name || '';
    useEffect(() => {
        const resize = () => setIsMobileScreen(window.innerWidth <= 991);
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    }, []);
    const expanded = isMobileScreen || !isCollapsed;
    const role = localStorage.getItem('elevva_role') || '10';
    const groups = menuGroups.map(group => ({ ...group, items: group.items.filter(item => item.roles.includes(role)) })).filter(group => group.items.length);
    return <aside className={`premium-sidebar-container ${expanded ? 'sidebar-expanded' : 'sidebar-compact'}`}>
        <div className="sidebar-header">
            <Link to="/dashboard/home" className="sidebar-logo-link" aria-label="Elevva · Inicio">
                <span className="sidebar-brand-mark"><ElevvaLogo fill="white" collapsed /></span>
                {expanded && <span className="sidebar-brand-copy"><span className="sidebar-brand-name" title={companyName}>{companyName || 'Mi empresa'}</span><span className="sidebar-company-name">ELEVVA CORP</span></span>}
            </Link>
            {isMobileScreen && <button type="button" className="sidebar-close-btn" onClick={toggleSidebar} aria-label="Cerrar menú"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" /></svg></button>}
        </div>
        <nav className="sidebar-nav" aria-label="Menú principal">
            {groups.map(group => <div className="sidebar-group" key={group.label}>
                {expanded && <div className="sidebar-section-label">{group.label}</div>}
                {group.items.map(item => <Tooltip key={item.path} text={expanded ? '' : item.label} position="right">
                    <NavLink to={item.path} aria-label={expanded ? undefined : item.label} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
                        <span className="sidebar-link-icon"><SidebarIcon name={item.icon} />{item.isPro && <span className="sidebar-plus" title="Plus" aria-label="Plus">✦</span>}</span>
                        {expanded && <span className="sidebar-link-text"><span className="sidebar-link-label">{item.label}</span>{item.subtitle && <span className="sidebar-link-subtitle">{item.subtitle}</span>}</span>}
                    </NavLink>
                </Tooltip>)}
            </div>)}
        </nav>
        <div className="sidebar-footer">
            <Tooltip text={expanded ? '' : 'Ayuda'} position="right"><a href="https://elevva.com.co/faq/" target="_blank" rel="noopener noreferrer" className="sidebar-link" aria-label={expanded ? undefined : 'Ayuda'}><span className="sidebar-link-icon"><SidebarIcon name="help" /></span>{expanded && <span className="sidebar-link-label">Ayuda</span>}</a></Tooltip>
            <Tooltip text={expanded ? '' : 'Cerrar sesión'} position="right"><button type="button" className="sidebar-link sidebar-logout-btn" onClick={logout} aria-label={expanded ? undefined : 'Cerrar sesión'}><span className="sidebar-link-icon"><SidebarIcon name="logout" /></span>{expanded && <span className="sidebar-link-label">Cerrar sesión</span>}</button></Tooltip>
        </div>
    </aside>;
}
